import * as React from 'react';

import classNames from 'classnames';

import {Divider} from 'shells/layout/divider';

import type {SessionUser, EventFragmentSparse} from 'nutshell-graphql-types';

import {TimelineEntryInboxThread} from './entry';
import {TimelineEvents} from './timeline-events';

import styles from './timeline-pinned-events.module.css';

type Props = {
    openThread: EventFragmentSparse | null | undefined;
    pinnedEvents: any[];
    entityId: string;
    entityPageName: string | null | undefined;
    user: SessionUser | null | undefined;
    onSetPinnedStatus: (arg1: {
        entityToPinId: string;
        pinToEntityId: string;
        status: boolean;
        userName: string;
        changeLogId: string;
    }) => Promise<any>;
    isOverview?: boolean;
};

export function TimelinePinnedEvents(props: Props) {
    if (!props.pinnedEvents.length && !props.openThread) {
        return <></>;
    }

    const containerClasses = classNames(styles.container, {
        [styles['container--overview']]: props.isOverview,
    });

    return (
        <div className={containerClasses}>
            {props.openThread && (
                <TimelineEntryInboxThread
                    event={props.openThread}
                    entityPageId={props.entityId}
                    entityPageName={props.entityPageName}
                    isPinnedThread={true}
                />
            )}
            {props.pinnedEvents && props.user ? (
                <TimelineEvents
                    timelineEvents={props.pinnedEvents}
                    currentUser={props.user}
                    entityPageId={props.entityId}
                    entityPageName={props.entityPageName}
                    hasGutterLine={false}
                    onSetPinnedStatus={props.onSetPinnedStatus}
                />
            ) : undefined}
            {!props.isOverview && <Divider variant='line--horizontal' />}
        </div>
    );
}
